import api from '@/utils/api';

/**
 * Get all the options for a specific company
 * @param {string} id - The company ID
 * @returns {Promise}
 */
export const getCompanyOptionWithPriceSelect = (id) =>
  api.get(`conf/${id}/options-select`);

export default { getCompanyOptionWithPriceSelect };
